/**
 * © [2025] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import { updateHeaderArray } from '../../../../../SharedModules/utilities/utilities';
import { formatDateToSortableDateStr } from '../../../../../SharedModules/DateUtilities/DateUtilities';

function monthToComparableNumber(date) {
  if (date === undefined || date === null) {
    return null;
  }
  let dt = date;
  if (date instanceof Date && !isNaN(date.getTime())) {
    dt = formatDateToSortableDateStr(date);
  }
  if (dt.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(dt.substring(6, 10));
  const dayNumber = Number.parseInt(dt.substring(3, 5));
  const monthNumber = Number.parseInt(dt.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}

function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

const IneligibleProvHeader = (localStorageValue, kcRoles) =>
  updateHeaderArray(
    [
      {
        headerName: 'Actions',
        cellRenderer: 'deleteBoxRenderer',
        filter: false,
        sortable: false,
        suppressMenu: false,
        showCheckboxIcon: true,
        minWidth: 80,
        cellStyle: {
          borderRightColor: Styles.BorderColor,
        },
        pdfExportOptions: {
          skipColumn: true,
        },
      },
      {
        headerName: 'CPT code',
        field: 'procedureCd',
        editable: false,
        sortable: true,
        suppressMenu: false,
        cellClass: 'frr-checkissuerField',
        wrapHeaderText: true,
        autoHeaderHeight: true,
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_130,
        cellRenderer: 'ProcedureCdCellRenderer',
        cellStyle: { borderRightColor: Styles.BorderColor },
        filter: 'agTextColumnFilter',
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        required: true,
      },

      {
        headerName: 'Ineligibility Period Begin Date',
        field: 'ineligBeginDt',
        wrapHeaderText: true,
        autoHeaderHeight: true,
        editable: false,
        suppressMenu: false,
        sortable: true,
        cellRenderer: 'StartDate',
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_200,
        isNumber: true,
        filter: 'agTextColumnFilter',
        comparator: dateComparator,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
        cellStyle: { borderRightColor: Styles.BorderColor },
        required: true,
      },
      {
        headerName: 'Ineligibility Period End Date',
        field: 'ineligEndDt',
        editable: false,
        suppressMenu: false,
        sortable: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        cellRenderer: 'ineligEndDtCellRenderer',
        cellEditor: MaxLengthNumericEditor,
        minWidth: Styles.Width_200,
        isNumber: true,
        filter: 'agTextColumnFilter',
        resizable: false,
        comparator: dateComparator,
        filterParams: {
          defaultOption: 'startsWith',
          suppressAndOrCondition: true,
          buttons: ['reset'],
          refreshValuesOnOpen: true,
        },
      },
    ],
    kcRoles
  );

export default IneligibleProvHeader;
